import { Dialog, DialogContent } from '@mui/material';
import { lighten, shade } from 'polished';
import styled from 'styled-components';

export const StyledDialog = styled(Dialog)``;

export const StyledDialogTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 2rem;
  border-bottom: 1px solid ${props => lighten(0.9, props.theme.colors.black)};
  font-weight: 600;
  background: ${props => props.theme.colors.primary};

  button {
    margin-left: 0.8rem;
  }
`;

export const StyledDialogTitle = styled.h3`
  font-size: 1rem;
  font-family: Poppins;
  font-weight: normal;
  color: ${props => props.theme.colors.white};
`;

export const StyledDialogContent = styled(DialogContent)`
  background-color: ${props => props.theme.colors.blackLight}
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${props => shade(0.1, props.theme.colors.white)};
`;
